export const PROGRESSIVE_LEASING_ESTIMATOR = {
  infoText: 'Lease-to-own. No credit needed.',
  estimatorLink: {
    linkText: 'Learn More',
    linkUrl: {
      destinationUrl: 'https://progressivelp.com/eComUI/#/apply/est-settings',
      type: 'externalLink',
    },
    ariaLabel: 'learn more',
  },
  requestType: 'pdp',
  payFrequency: 'biWeekly',
  storeId: '14467',
  approveMeName: 'mattressfirm',
  approveMeSlugValue: '099011',
};
